import { render, staticRenderFns } from "./PayrollMoneyInput.vue?vue&type=template&id=f956dc7e&"
import script from "./PayrollMoneyInput.vue?vue&type=script&lang=js&"
export * from "./PayrollMoneyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports